module.exports = "http://cdn.realive.com.ua/src/views/donate/main/elements/shop/img/sapper.png";